var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHabitsCustomisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8302 9.08652C14.9455 11.2019 14.9455 14.6315 12.8302 16.7469C10.7149 18.8622 7.28521 18.8622 5.16986 16.7469C3.05453 14.6315 3.05453 11.2019 5.16986 9.08652C7.2852 6.97119 10.7148 6.97119 12.8302 9.08652Z",
    fill: "#FFF0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75003 11.6667L9.00003 10.8334V15",
    fill: "#FFF0BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95836 15H10.0417H7.95836Z",
    fill: "#FFF0BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94589 9.32417L1.77527 3.65045C1.4107 2.99806 1.22841 2.67186 1.25913 2.40479C1.28594 2.17178 1.40969 1.96085 1.60002 1.82379C1.81817 1.66669 2.19185 1.66669 2.93919 1.66669H4.80155C5.07929 1.66669 5.21817 1.66669 5.34273 1.7068C5.45295 1.74229 5.55457 1.80037 5.6411 1.87732C5.73888 1.96429 5.80937 2.08394 5.95035 2.32325L9.00003 7.50002L12.0497 2.32325C12.1907 2.08394 12.2612 1.96429 12.359 1.87732C12.4455 1.80037 12.5471 1.74229 12.6573 1.7068C12.7819 1.66669 12.9208 1.66669 13.1985 1.66669H15.0609C15.8082 1.66669 16.1819 1.66669 16.4 1.82379C16.5904 1.96085 16.7141 2.17178 16.7409 2.40479C16.7716 2.67186 16.5894 2.99806 16.2248 3.65045L13.0542 9.32417M7.75003 11.6667L9.00003 10.8334V15M7.95836 15H10.0417M12.8302 9.08652C14.9455 11.2019 14.9455 14.6315 12.8302 16.7469C10.7149 18.8622 7.28521 18.8622 5.16986 16.7469C3.05453 14.6315 3.05453 11.2019 5.16986 9.08652C7.2852 6.97119 10.7148 6.97119 12.8302 9.08652Z",
    stroke: "#0D3355",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabitsCustomisation);
export default __webpack_public_path__ + "static/media/habits-customisation.42143e4e.svg";
export { ForwardRef as ReactComponent };